import React from 'react';

import { CompareContext } from '@neptune/compare-domain';

export function useCompareContext() {
  return React.useContext(CompareContext);
}
